module.exports = __webpack_public_path__ + "img/icon-meeting.07dbcea8.svg";